import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

import * as AuthForm from 'auth/components/form';
import { InlineMessages } from 'messages/containers';

class ResetPasswordView extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleValidation: PropTypes.func.isRequired,
    handleValueChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isSubmitted: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    values: PropTypes.shape({ email: PropTypes.string, password: PropTypes.string }),
  };
  render = () => (
    <AuthForm.Wrapper>
      <h1 className="mb-4">{this.props.t('reset_password.title')}</h1>
      <p className="lead mb-4">{this.props.t('reset_password.subtitle')}</p>
      <div className="messages-container">
        <InlineMessages />
      </div>
      <AuthForm.ResetPasswordForm
        handleSubmit={this.props.handleSubmit}
        handleValidation={this.props.handleValidation}
        handleValueChange={this.props.handleValueChange}
        isLoading={this.props.isLoading}
        isSubmitted={this.props.isSubmitted}
        values={this.props.values}
      />
    </AuthForm.Wrapper>
  );
}

export default translate()(ResetPasswordView);



// WEBPACK FOOTER //
// src/modules/auth/components/ResetPasswordView.js